<script setup lang="ts">
  import { computed } from 'vue';
  import { useMatrixFillLabContext } from '../../model/useMatrixFillLab';

  const props = withDefaults(defineProps<{ id: string; label?: string; locate?: boolean }>(), {
    label: undefined,
    locate: true,
  });

  const lab = useMatrixFillLabContext();

  const label = computed(() => props.label ?? lab.elementLabels.value.get(props.id) ?? props.id);
  const isField = computed(() => lab.compiled.value?.fields[props.id] !== undefined);
  const clickable = computed(() => props.locate && isField.value);
</script>

<template>
  <component
    :is="clickable ? 'button' : 'span'"
    :type="clickable ? 'button' : undefined"
    class="inline-flex min-w-0 max-w-full items-baseline gap-1.5 text-left"
    :class="{ 'hover:underline': clickable }"
    @click="clickable && lab.locateField(id)"
  >
    <span class="truncate font-medium">{{ label }}</span>
    <code class="shrink-0 text-[10px] text-[var(--color-gray-04)]">{{ id }}</code>
  </component>
</template>
